import type { ImageProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { NumberField, SelectField, TextField } from "./fields.js";
import { MediaField } from "./MediaField.js";
import type { WidgetInspectorProps } from "./registry.js";

const FIT = ["cover", "contain", "fill", "scale-down"] as const;

export function ImageInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as ImageProps;

  return (
    <>
      <MediaField
        label="Source URL"
        value={p.src}
        onChange={(v) => update(widget.id, { src: v })}
      />
      <TextField
        label="Alt text"
        value={p.alt}
        onChange={(v) => update(widget.id, { alt: v })}
      />
      <SelectField
        label="Fit"
        value={p.fit ?? "cover"}
        options={FIT}
        onChange={(v) => update(widget.id, { fit: v })}
      />
      <div className="emke-inspector-grid-2" style={{ padding: "0 16px" }}>
        <NumberField
          label="Width"
          value={p.width ?? 0}
          min={0}
          onChange={(v) => update(widget.id, { width: v || undefined })}
        />
        <NumberField
          label="Height"
          value={p.height ?? 0}
          min={0}
          onChange={(v) => update(widget.id, { height: v || undefined })}
        />
      </div>
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 0}
        min={0}
        max={999}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
